<a href="/"><img class="projectzen-logo" src="/assets/projectzen_logo.jpg" alt="projectzen_logo.jpg" /></a>
<a class="small-button position-top-right" href="login">Log In</a>
<h2 class="subheader">
  Please check your <span class="user-account-email"></span> email <br />to verify
  your account address before logging in.
</h2>
<div class="container send-again-button-container">
  <button class="send-again-button" class="btn btn-secondary" (click)="sendVerificationEmailAgain()">
    Send again
  </button>
</div>
@if (showSuccessMessage) {
<p class="another-email-sent-confirmation-text">Email sent.</p>
}
<app-page-footer></app-page-footer>